import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const GallBladderStonesPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Gall Bladder Stones</h1>
        <section className="mb-8">
          <p>Gall bladder stones are hardened deposits that form in the gall bladder, often causing pain and digestive issues. Our natural therapies focus on dissolving stones, improving bile flow, and preventing new stone formation through gentle, non-invasive methods.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>High cholesterol levels</li>
            <li>Poor diet</li>
            <li>Obesity</li>
            <li>Rapid weight loss</li>
            <li>Hormonal factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Abdominal pain</li>
            <li>Nausea and vomiting</li>
            <li>Digestive discomfort</li>
            <li>Bloating</li>
            <li>Jaundice (in severe cases)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use stone-dissolving herbs, dietary modifications, and lifestyle changes to naturally treat gall bladder stones. Our approach focuses on improving bile flow, reducing inflammation, and preventing stone formation through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-surgical treatment</li>
            <li>Dissolves stones naturally</li>
            <li>Improves digestive health</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a low-fat, high-fiber diet</li>
            <li>Stay hydrated</li>
            <li>Maintain a healthy weight</li>
            <li>Regular exercise</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment dissolve gall stones?</strong>
            <p>A: Yes, our natural approach can help dissolve stones and improve gall bladder function.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe?</strong>
            <p>A: Yes, our treatments are gentle and focus on natural healing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does treatment take?</strong>
            <p>A: Treatment duration varies, but many patients see improvement within a few months.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from gall stones—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default GallBladderStonesPage; 